import * as React from 'react';
import { LoadingPage } from '../pages/components/loading/index.';
import { useAuthProvider } from './AuthProvider.component';

export interface IUser {
  job_number: string | undefined;
  quote_id: string | undefined;
}

interface AuthContextType {
  user: IUser | null;
  loading: boolean;
  signInCustomer: (job_number: string, postcode: string) => Promise<boolean>;
  signInQuote: (quote_id: string, postcode: string) => Promise<boolean>;
  signout: () => void;
}

let AuthContext = React.createContext<AuthContextType>(null!);

export function AuthProvider({children}: { children: React.ReactNode }) {
  const auth = useAuthProvider();

  if (auth.loading) {
    return <LoadingPage />
  }

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return React.useContext(AuthContext);
}